const animationTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';

export default (theme) => ({
    '@keyframes badgeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    '@keyframes bounceIn': {
        from: {
            animationTimingFunction,
        },
        '0%': {
            opacity: 0,
            transform: 'scale3d(0.3, 0.3, 0.3)',
        },
        '20%': {
            transform: 'scale3d(1.5, 1.5, 1.5)',
            animationTimingFunction,
        },
        '40%': {
            transform: 'scale3d(0.9, 0.9, 0.9)',
            animationTimingFunction,
        },
        '60%': {
            opacity: 1,
            transform: 'scale3d(1.2, 1.2, 1.2)',
            animationTimingFunction,
        },
        '80%': {
            transform: 'scale3d(0.97, 0.97, 0.97)',
            animationTimingFunction,
        },
        to: {
            opacity: 1,
            transform: 'scale3d(1, 1, 1)',
            animationTimingFunction,
        },
    },
    root: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '0px 8px',
        textDecoration: 'none',
        borderRadius: '8px',
        transition: 'all .2s ease',
        minWidth: 40,
        cursor: 'pointer',
        '&:not($isActive):hover': {
            backgroundColor: theme.colors.grey[700],
        },
    },
    icon: {
        width: 40,
        height: 40,
        padding: '12px 8px',
        flexShrink: 0,
    },
    label: {
        ...theme.typography.button,
        position: 'absolute',
        zIndex: 2,
        left: 40,
        width: '100%',
        maxWidth: 'calc(100% - 50px)',
        color: theme.colors.transparent,
        display: 'inline-block',
        opacity: 0,
        willChange: 'opacity',
        whiteSpace: 'nowrap',
        transition: 'opacity .4s linear',
    },
    newBadge: {
        color: theme.colors.primary.brilliantGreen,
        width: 4,
        height: 4,
        position: 'absolute',
        left: -6,
        zIndex: 0,
        transform: 'translate3d(0,0,0)',
        opacity: 0,
    },
    notificationBadge: {
        color: theme.colors.textDark.primary,
        backgroundColor: theme.colors.primary.brilliantGreen,
        fontSize: 0,
        width: 8,
        height: 8,
        borderRadius: '50%',
        position: 'absolute',
        left: 22,
        top: 22,
        zIndex: 0,
        opacity: 1,
    },
    hasBadge: {
        paddingRight: 32,
    },
    hasTrial: {
        paddingRight: 20,
    },
    trialIcon: {
        width: 18,
        height: 18,
        flexShrink: 0,
        position: 'absolute',
        top: 11,
        right: 8,
        opacity: 0,
        pointerEvents: 'none',
        color: theme.colors.primary.brilliantGreen,
    },
    isExpanded: {
        margin: '0px 8px',
        '& $label': {
            opacity: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: theme.colors.textDark.primary,
        },
        '& $newBadge': {
            right: 8,
            lineHeight: 1.6,
            width: 'auto',
            height: 'auto',
            left: 'auto',
            opacity: 1,
        },
        '& $trialIcon': {
            opacity: 1,
        },
    },
    shouldAnimate: {
        '&$notificationBadge': {
            animationDuration: '1s',
            animationName: '$bounceIn',
            animationIterationCount: 1,
            animationFillMode: 'forwards',
        },
        '&$newBadge': {
            opacity: 0,
            animationName: '$badgeIn',
            animationDuration: '.2s',
            animationDelay: '.5s',
            animationIterationCount: 1,
            animationFillMode: 'forwards',
        },
        '&$trialIcon': {
            opacity: 0,
            animationName: '$badgeIn',
            animationDuration: '.2s',
            animationDelay: '.5s',
            animationIterationCount: 1,
            animationFillMode: 'forwards',
        },
    },
    isActive: {
        backgroundColor: theme.colors.grey[600],
    },
});
